import { faImage } from '@fortawesome/free-solid-svg-icons';
import cx from 'classnames';
import Link from 'next/link';
import { useMemo } from 'react';

import { CustomIcon } from '@/components/CustomIcon';
import { MediaUrls, getMediaUrls } from '@/utils/getMediaUrls';

import styles from '../PreviewCard.module.scss';
import { EAspect, ICollectionCardProps } from '../PreviewCard.types';

export const CollectionCard: React.FC<ICollectionCardProps> = ({
  data,
  innerRef,
}) => {
  const { posterUrl } =
    (getMediaUrls(data.items[0]?.content?.mediaEndpoints) as MediaUrls) || {};

  const query = useMemo(
    () => ({
      title: data.title,
      canDelete: data?.isDefault === undefined ? false : !data.isDefault,
      collectionId: data.id,
    }),
    [data.title, data?.isDefault, data.id],
  );

  const formatVideoCount = (count: number) =>
    count === 1 ? '1 video' : `${count} videos`;

  const collectionSize = formatVideoCount(data.items.length);

  return (
    <Link
      href={{
        pathname: `/favorites/${data.id}`,
        query,
      }}
      prefetch={false}
      className={styles.anchor}
    >
      <div
        className={cx(styles['preview-card'], styles[EAspect.SQUARE])}
        ref={innerRef}
      >
        {posterUrl ? (
          <div
            className={styles.thumb}
            style={{ backgroundImage: `url(${posterUrl})` }}
          />
        ) : (
          <div className={styles.thumb}>
            <CustomIcon icon={faImage} className={styles.icon} />
          </div>
        )}
        <div
          className={cx(styles['title-container'], styles['title-collection'])}
        >
          <h2 className={styles.title}>{data.title}</h2>
          <h3 className={styles.subtitle}>{collectionSize}</h3>
        </div>
      </div>
    </Link>
  );
};
